import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import alert from "./components/Alert.vue";

Vue.config.productionTip = false;
axios.defaults.baseURL =
  process.env.VUE_APP_API_URL || "http://127.0.0.1:8000/api";
axios.defaults.timeout = 15000;
require("@/store/subscriber");
store.dispatch("auth/attempt", localStorage.getItem("token"));

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  created() {
    Vue.component("alert", alert);
  },
}).$mount("#app");
